const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Button, Container, LinearProgress, Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useState } from 'react';
import Page from '@/Components/templates/Page';
import { useAuthStore } from '@/Utility/auth/Auth';
import { ImageZnglyLogoTransparent } from '@/assets/images';
import { toast } from 'react-toastify';
import { type Auth_LoginClients_Query, type Auth_LoginClients_Query$data, LoginClientsQuery } from '@/graphql/queries/Auth.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { loadQuery } from 'react-relay';
import { ForgotPasswordForm } from './-lib/forgot-password-form';
import { LoginForm } from './-lib/login-form';
import './login.less';
type Props = {
  isFallback?: boolean;
  data?: Auth_LoginClients_Query$data;
};
export type { Props as LoginProps };
const Login = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState<'login' | 'forgot'>('login');
  return <Page>
      <Container className="LoginContainer">
        {loading && <LinearProgress sx={{
        width: '100%',
        height: '3px',
        position: 'sticky',
        top: '0',
        zIndex: 100
      }} />}

        <img src={ImageZnglyLogoTransparent} />

        {formType === 'login' ? <LoginForm {...props} loading={loading} setLoading={setLoading} /> : <ForgotPasswordForm loading={loading} setLoading={setLoading} onFormSend={() => {
        setFormType('login');
        toast.success('Password reset email sent. Check your email for further instructions.');
      }} />}
      </Container>

      <Stack style={{
      marginTop: '1em',
      width: '100%'
    }} alignItems="center">
        <Button className="z-btn-1" onClick={() => setFormType(formType === 'login' ? 'forgot' : 'login')} size="small" style={{
        border: 'none'
      }} disabled={loading || props?.isFallback}>
          {formType === 'login' ? 'Forgot Your Password?' : 'Back to Login'}
        </Button>
      </Stack>
    </Page>;
};
export const Route = createFileRoute('/auth/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  pendingComponent: () => <Login isFallback />,
  beforeLoad: () => {
    const userExists = useAuthStore.getState()?.user?.userExists;
    if (userExists === true) {
      throw redirect({
        to: '/dash/catalog'
      });
    }
  },
  loader() {
    return loadQuery<Auth_LoginClients_Query>(RelayEnvironment, LoginClientsQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  }
});